import userDlgMul from "./userDlgMul.js";

const schoolMan = {
  namespaced: true,
  modules: {
    userDlgMul
  }
};

export default schoolMan;
